export default __webpack_public_path__ + "static/media/info-circle.364aa4db.svg";